@import '../shared/media.css';

.root {
  margin-inline: auto;

  @media (width >= v-sm) {
    padding-inline: 1rem;
  }
}
